import { createTheme } from '@material-ui/core/styles'

export const theme = createTheme({
/*    overrides: {
      MuiButton: {
        root: {                
          "& $label": {
            fontSize: "1rem",
          }
        },
      }
    }
*/
});